export default __webpack_public_path__ + "images/56_thumbnail.jpg";